// Color temperature dots on product cards: switch the card's photo, price and link to that variant.
(function () {
  function choose(button) {
    var card = button.closest('.card-wrapper');
    if (!card) return;
    var data = button.dataset;
    var onSale = !!data.compare;
    button.parentElement.querySelectorAll('button').forEach(function (b) {
      b.classList.toggle('on', b === button);
    });
    var image = card.querySelector('.card__media img');
    if (image && data.image) {
      image.removeAttribute('srcset');
      image.src = data.image;
    }
    card.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(function (el) {
      el.textContent = data.price;
    });
    var was = card.querySelector('.price__sale s');
    if (was) was.textContent = data.compare || '';
    var price = card.querySelector('.price');
    if (price) price.classList.toggle('price--on-sale', onSale);
    card.querySelectorAll('.card__badge .badge').forEach(function (badge) {
      badge.style.display = onSale ? '' : 'none';
    });
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      link.href = link.href.split('?')[0] + '?variant=' + data.variant;
    });
  }

  // The card's full-size link sits on top of the dots, so match clicks by position.
  document.addEventListener(
    'click',
    function (event) {
      var card = event.target.closest && event.target.closest('.card-wrapper');
      if (!card) return;
      var buttons = card.querySelectorAll('.hgS button');
      for (var i = 0; i < buttons.length; i++) {
        var r = buttons[i].getBoundingClientRect();
        if (r.width && event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom) {
          event.preventDefault();
          event.stopPropagation();
          choose(buttons[i]);
          return;
        }
      }
    },
    true
  );
})();
